/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="79.03"
        viewBox="0 0 95.58 79.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M20.35 23.12A11.16 11.16 0 1 0 31.5 34.28a11.16 11.16 0 0 0-11.15-11.16Zm0 2.5a8.66 8.66 0 1 1-8.66 8.66 8.66 8.66 0 0 1 8.66-8.66ZM28.7 51.24a1.25 1.25 0 0 1 .12 2.49H10.63a8.14 8.14 0 0 0-8.13 7.89v1.65a1.25 1.25 0 0 1-2.49.13v-1.53a10.65 10.65 0 0 1 10.34-10.63H28.7ZM75.24 23.12a11.16 11.16 0 1 0 11.15 11.16 11.16 11.16 0 0 0-11.15-11.16Zm0 2.5a8.66 8.66 0 1 1-8.66 8.66 8.66 8.66 0 0 1 8.66-8.66ZM84.95 51.24a10.63 10.63 0 0 1 10.63 10.34v1.69a1.25 1.25 0 0 1-2.49.13v-1.53a8.13 8.13 0 0 0-7.88-8.13H66.89a1.25 1.25 0 0 1-.13-2.49h18.19ZM47.79 37.64a11.16 11.16 0 1 0 11.16 11.15 11.15 11.15 0 0 0-11.16-11.15Zm0 2.5a8.66 8.66 0 1 1-8.65 8.65 8.66 8.66 0 0 1 8.65-8.65ZM57.5 65.76A10.64 10.64 0 0 1 68.14 76.1v1.68a1.25 1.25 0 0 1-2.49.13v-1.52a8.13 8.13 0 0 0-7.88-8.13H38.08a8.13 8.13 0 0 0-8.13 7.88v1.64a1.252 1.252 0 0 1-2.5.13v-1.52a10.62 10.62 0 0 1 10.34-10.63H57.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M46.29 0v2.75l-.42.07-.43.09a6.57 6.57 0 0 0-5 4 8 8 0 0 0-.57 3.75 6.44 6.44 0 0 0 3.44 5.47 27.57 27.57 0 0 0 2.92 1.37c1.21.5 2.44 1 3.64 1.48a2.19 2.19 0 0 1 1.37 2.4 2.39 2.39 0 0 1-1.92 2.4 7.17 7.17 0 0 1-1.53.17 3.8 3.8 0 0 1-3.87-2.83c-.11-.34-.19-.68-.29-1.06l-4.6 1.19a9.45 9.45 0 0 0 2.22 4.55 7.7 7.7 0 0 0 5 2.33v3.56h3v-3.57c.6-.12 1.18-.21 1.75-.36a6.88 6.88 0 0 0 4.84-3.93 8 8 0 0 0 .55-4.79 6.33 6.33 0 0 0-3.2-4.54 35.07 35.07 0 0 0-4.4-1.92c-.9-.36-1.78-.78-2.65-1.2a2 2 0 0 1-1-1.2 2.68 2.68 0 0 1 1.88-3.38 3.12 3.12 0 0 1 3.08.8 5.72 5.72 0 0 1 1.26 1.9l.3.7 4.12-1.7a8.33 8.33 0 0 0-1.52-3.11 7.25 7.25 0 0 0-5-2.6V0Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreePeopleWithDollarSignIcon';

export default Icon;
